/* src/components/settings/sections/AdvancedSettingsSection.js */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlask } from '@fortawesome/free-solid-svg-icons';
import {
    SectionCard,
    ToggleSwitch,
    LoadingSpinner
} from '../SettingSectionComponents';

const AdvancedSettingsSection = ({
    localEnableExperimentalFeatures,
    onEnableExperimentalFeaturesChange, // This will be setLocalEnableExperimentalFeatures
    isGeneralSectionDisabled,
    isSavingAppSettings,
    appSaveStatus,
    onSaveAdvancedSettings
}) => {
    return (
        <SectionCard title="Advanced Settings" icon={faFlask}>
            <div className="space-y-3 divide-y divide-gray-200">
                <ToggleSwitch
                    label="Enable Experimental Features"
                    description="Access experimental and beta features. These may be unstable or change frequently."
                    checked={localEnableExperimentalFeatures}
                    onChange={onEnableExperimentalFeaturesChange} // Directly pass the setter
                    disabled={isGeneralSectionDisabled}
                />
            </div>
            {/* Save Button Area for Advanced Settings */}
            <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-end space-x-3">
                {appSaveStatus.section === 'advanced' && appSaveStatus.message && (
                    <span className={`text-sm font-medium ${appSaveStatus.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                        {appSaveStatus.message}
                    </span>
                )}
                <button
                    onClick={onSaveAdvancedSettings}
                    disabled={isGeneralSectionDisabled}
                    className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 transition-colors flex items-center justify-center min-w-[180px] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    {isSavingAppSettings && appSaveStatus.section === 'advanced' ? (
                        <><LoadingSpinner /> Saving...</>
                    ) : (
                        'Save Advanced Settings'
                    )}
                </button>
            </div>
        </SectionCard>
    );
};

export default AdvancedSettingsSection;